import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/browser';
import { ReduxApp } from './App';
import './i18n';

import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://cfcc11364766440ca192d7e74bfb561f@sentry.io/1516587',
    release: `patient@${process.env.REACT_APP_GIT_SHA || 'dev'}`,
  });
}

createRoot(document.getElementById('root')!).render(<ReduxApp />);
